import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header, Nav, HamburgerMenu, BtnSave } from './components'

import { 
    loginUserCheck, 
    logoutUser,
    promotionCreate
} from '../redux/actions'

class AdminAddPromotion extends Component {

    constructor(){
        super()
        this.state = {
            thumbnail: "",
            photo: "",
            title: "",
            desc: "",
            sub_desc: "",
            toggleMenu: false
        }
    }

    componentWillMount() {
        this.props.loginUserCheck()
    }

    _handleMenu() {
        this.setState({ toggleMenu: !this.state.toggleMenu })
    }

    _handleLogout() {
        this.props.logoutUser()
    }

    _onHandleChange(event) {
        if(event.target.files) {
            this.setState({
                [event.target.name]: event.target.files[0]
            })
        } else {
            this.setState({
                [event.target.name]: event.target.value
            })
        }
    }

    _onSubmit() {
        let { thumbnail, photo, title, sub_desc, desc } = this.state
        let data = {
            promo_id: (new Date()).getTime(),
            thumbnail,
            photo,
            title,
            desc,
            sub_desc,
            created_by: this.props.user
        }
        if(thumbnail && photo && title && desc && sub_desc) {
            this.props.promotionCreate(data)
        } else {
            alert("Please fill in a form...")
        }
    }

    render() {
        if(!this.props.user) return  <div></div> 
        return (
            <div>
                <Header name={this.props.user} logout={() => this._handleLogout()}/>
                <div className="admin-addpromotion">
                    <Nav active="promotion"/>
                    <div className={(this.state.toggleMenu)? "content moveover": "content"}>
                        <div className="content-inner">
                            <HamburgerMenu onClick={()=>this._handleMenu()} />
                            <div className="title">
                                <h2>โปรโมชั่น : เพิ่มรายการ</h2>
                            </div>
                            <div className="info">
                                <div className="adjust">
                                    <form action="" className="photo">
                                        <div className="promotion-title">
                                            <p>Thumbnail โปรโมชั่น (308x237px)</p>
                                        </div>
                                        <div className="filename">
                                            <p>{this.state.thumbnail.name}</p>
                                        </div>
                                        <div className="photo-input">
                                            <input id="thumbnail" type="file" name="thumbnail" accept="image/*" hidden onChange={(event) => this._onHandleChange(event)}/>
                                            <label htmlFor="thumbnail">เลือกรูปภาพ</label>
                                        </div>
                                    </form><br/>
                                    <form action="" className="photo">
                                        <div className="promotion-title">
                                            <p>รูปภาพโปรโมชั่น (414x173px)</p>
                                        </div>
                                        <div className="filename">
                                            <p>{this.state.photo.name}</p>
                                        </div>
                                        <div className="photo-input">
                                            <input id="photo" type="file" name="photo" accept="image/*" hidden onChange={(event) => this._onHandleChange(event)}/>
                                            <label htmlFor="photo">เลือกรูปภาพ</label>
                                        </div>
                                    </form>
                                    <form className="text">
                                        <div className="promotion-name">
                                            <p>ชื่อโปรโมชั่น</p>
                                            <input type="text" name="title" onChange={(event) => this._onHandleChange(event)}></input>
                                        </div>
                                        <div className="actual-price">
                                            <p>รายละเอียดย่อ</p>
                                            <input type="text" name="sub_desc" onChange={(event) => this._onHandleChange(event)}></input>
                                        </div>
                                        <div className="discount-price">
                                            <p>รายละเอียด</p>
                                            <textarea name="desc" onChange={(event) => this._onHandleChange(event)} />
                                        </div>
                                    </form>
                                    <div className="btn-submit">
                                        {
                                            (this.props.loading) ?
                                            <p style={{textAlign: 'center'}}>Loading...</p>
                                            : <BtnSave click={() => this._onSubmit()}/>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
const mapStateToProps = ({ auth, promotion }) => {
    return { 
        user: auth.user,
        loading: promotion.loading
    }
}
 
export default connect(mapStateToProps, { 
    loginUserCheck, logoutUser, promotionCreate
})(AdminAddPromotion)